import React, { Component } from 'react'
import Included from '../Included'
import commonUI from '../../../js/commonUI'
import DarkThemeNav from '../common/dark-theme-nav';

class Loaders extends Component {

  constructor(props) {
    super(props)
    this.state = {
      theme: 'default',
    };
  }

  handleClick() {
    let loader = commonUI.initializeLoader();
    setTimeout(() => loader.destroy(), 3000);
  }

  handleClickTargeted() {
    let loader = commonUI.initializeLoader({selector: '.js-custom-loader', fullscreen: false});
    setTimeout(() => loader.destroy(), 3000);
  }

  handleClickTargetedMessage() {
    let loader = commonUI.initializeLoader({selector: '.js-custom-loader', fullscreen: false, message: 'Custom messaging...'});
    setTimeout(() => loader.destroy(), 3000);
  }

  handleClickTheme() {
    let loader = commonUI.initializeLoader({selector: '.js-custom-loader', fullscreen: false, theme: 'light', message: 'Light themed...'});
    setTimeout(() => loader.destroy(), 3000);
  }

  handleClickProgressWording() {
    let loader = commonUI.initializeLoader({ message: [ { changeAt: 0, text: 'Loading...' }, { changeAt: 2, text: 'Still loading...' }, { changeAt: 4, text: 'Still working on your request...' } ] });
    setTimeout(() => loader.destroy(), 6000);
  }

  render (){
    return(
    <section><a className="anchor" id="loaders"></a>
    <h2>Loaders</h2>
    <div style={{"position": "relative","minHeight": "6.5em", "zIndex":"1"}}>
      <div className="loader-overlay soft" style={{"height": "0%","position": "relative"}}>
        <div className="loader-wrapper" style={{"position": "relative","width": "5em"}}>
          <div className="loader" style={{"marginTop": "0"}}>
          </div>
          <p>Loading...</p>
        </div>
      </div>
      <br/>
      <div className="loader-overlay soft" style={{"height": "0%","position": "relative"}}>
        <div className="loader-wrapper" style={{"position": "relative","width": "5em"}}>
          <div className="loader loader--small" style={{"marginTop": "0"}}>
          </div>
          <p>Loading...</p>
        </div>
      </div>
    </div>

    <p>Adding <code>.loader--small</code> to the 'loader' div will use the smaller size.</p>
    <br/>
    <DarkThemeNav anchor="loaders" />

    <p>Full page loaders can be achieved by adding the <code>.js-loader</code> class to the <code>body</code> tag.<br/>
    This loader is fixed to the center of the screen - even if the content is scrollable, the loader will always be in view.</p>

    <button type="btn" className="btn" onClick={this.handleClick}>Click for full screen demo</button>
      <br/><br/>
        <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
        <pre className="hide-code"><code className="language-html">{`<html>
  <body class="js-loader">
  </body>
</html>`}</code></pre>
      <br/>
<pre className="hide-code"><code className="language-js">{`commonUI.initializeLoader()`}</code></pre>


    <p>To cover a specific area, you can pass a selector to define the area.</p>
    <div className="callout callout--secondary">
      <span><i className="fa fa-exclamation">  </i> Make sure the element you are trying to cover is set to <b>position: relative</b> to allow the loader to overlay it.<br/>
      This can be achieved by adding the helper <b>.position--relative</b> to the element.
      </span>
    </div>
    <br/><br/>
    <div style={{"position": "relative"}} className="well js-custom-loader">Custom area to cover with a loader. <br/> This div has the class - js-custom-loader <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/></div>
    <br/>
    <button type="btn" className="btn" onClick={this.handleClickTargeted}>Click for targetted demo</button>
    <br/><br/>
    <pre><code className="language-js">{`commonUI.initializeLoader({selector: '.js-custom-loader', fullscreen: false})`}</code></pre>
    <br/>
    <button type="btn" className="btn" onClick={this.handleClickTargetedMessage}>Click for demo with customized message</button>
    <br/><br/>
    <pre><code className="language-js">{`commonUI.initializeLoader({selector: '.js-custom-loader', fullscreen: false, message: 'Custom messaging...'})`}</code></pre>
    <br/>
      <button type="btn" className="btn" onClick={this.handleClickTheme}>Click for demo with light theme</button>
      <br/><br/>
      <pre><code className="language-js">{`commonUI.initializeLoader({selector: '.js-custom-loader', fullscreen: false, theme: 'light', message: 'Light themed...'}`}</code></pre>
    <br/><br/>
    <p>To close the loader, you must call the destroy method when you have finished loading. The following is a jquery example.</p>
    <pre><code className="language-js">{`var loader = commonUI.initializeLoader();
$.post( "test.php", { name: "John", time: "2pm" })
.done(function( data ) {
  loader.destroy();
  // Do stuff
});`}</code></pre>
<br/><br/>
    <p>You can defer the loader until required.</p>
    <pre><code className="language-js">{`var loader = commonUI.initializeLoader({deferred: true});
// Loader not shown.
// Start will show loader
loader.start();
// Do stuff
// Stop will destroy loader
loader.stop();
// Could show loader again
// loader.start();`}</code></pre>
<br/><br/>
      <p>When you know a process is going to take longer than a few seconds, you can add progression wording so that user knows it is still in progress.<br/>You can specify after how many seconds the wording should change and what it should change to using the code below:</p>
<pre><code className="language-js">{`var loader = commonUI.initializeLoader({
 message: [
   {
      changeAt: 0,  // Number of seconds to change wording at
      text: "Loading..." // Initial wording
   },
   {
      changeAt: 5,  // Number of seconds to change wording at
      text: "Still loading..." // New wording
   },
   {
      changeAt: 10,
      text: "Still working on your request..."
    }
  ]
});`}</code></pre>
      <br/>
      <button type="btn" className="btn" onClick={this.handleClickProgressWording}>Click for demo of progressive wording</button>
      <br/><br/>
      <hr />
    </section>
  )
}
}

export default Loaders



// WEBPACK FOOTER //
// ./styleguide/components/sections/Loaders.js